<script setup lang="ts">
import { THEME } from '@pkg/config/misc/theme';
import { colors } from '@pkg/config/tailwind/colors';
import { useSocialShare } from '~/app/composables/useSocialShare';
import { useIdleFlag } from '~/app/composables/useIdleFlag';

const props = defineProps<{
  title?: string,
  theme?: THEME,
  customTitle?: string,
  customDescription?: string,
}>();

const {
  socialLinksArray,
  openShareWindow,
  isThereNativeDeviceMenu,
  openNativeDeviceMenu,
  showDesktopVersion,
} = useSocialShare(props?.customTitle, props?.customDescription);

const themeColors = colors();
const { isIdle } = useIdleFlag();

// Get current page URL safely (works on both server and client)
const requestURL = useRequestURL();
const currentPageUrl = computed(() => requestURL.href);
</script>

<template>
  <ClientOnly>
    <div v-if="isIdle" :class="['flex flex-col flex-wrap max-w-full items-center justify-center gap-y-8 body-large font-bold text-primary', theme === THEME.LIGHT ? 'text-white' : 'text-primary' ]">
      <p>{{ title || $t('socialShareTitle') }}</p>
      <!-- Desktop -->
      <div>
        <div v-if="showDesktopVersion" class="flex flex-row flex-wrap items-center justify-center gap-x-24 text-32 text-white">
          <div v-for="link in socialLinksArray" :key="link.title">
            <button @click="openShareWindow(link.title)">
              <SocialLink :color="themeColors.primary['20']" :link="{ _type: 'socialLink', _key: 'link.key', url: `${link.basicLink}${currentPageUrl}`, icon: link.icon, title: link.title }" :aria-label="`Visit Too Good To Go's ${link.title}`" />
            </button>
          </div>
        </div>
        <!-- Device -->
        <div v-if="isThereNativeDeviceMenu" class="flex lazy-load-socials">
          <button @click="openNativeDeviceMenu">
            <CmsIcon name="Share2" :class="['hover:text-green-30 active:text-green-30 text-32', theme === THEME.LIGHT ? 'text-white' : 'text-primary' ]" />
          </button>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>
